<div class="icon-paragraph-root">
  <app-circle *ngIf="icon">
    {{icon}}
  </app-circle>
  <app-label class="big text" isBig>
    {{title}}
  </app-label>
  <app-label class="small text" isGray>
    {{paragraph}}
  </app-label>
</div>
